import { render, staticRenderFns } from "./AssignArticleModal.vue?vue&type=template&id=9f4ca760&"
import script from "./AssignArticleModal.vue?vue&type=script&lang=js&"
export * from "./AssignArticleModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignArticleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports